import React, { Component } from 'react'
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBContainer, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/pro-duotone-svg-icons'
import { Link } from 'gatsby'

class NavBarPage extends Component {
  state = {
    collapsed: false,
  }

handleTogglerClick = () => {
  this.setState({
    collapsed: !this.state.collapsed,
  })
}

componentDidMount() {  
  const str = window.location.pathname.substr(1,window.location.pathname.length-1)
  const len = str.indexOf("/")
  this.setState({ 
    parentNav: len < 0 ? str : str.substr(0, len) 
  })
}

render() {
  const overlay = (
    <div
      id="sidenav-overlay"
      style={{ backgroundColor: 'transparent' }}
      onClick={this.handleTogglerClick}
    />
  )

  const isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "nav-link active" } : {}
  }

  const isPartiallyActive = ({
    isPartiallyCurrent
  }) => {
    return isPartiallyCurrent
      ? { className: "nav-link active" }
      : {}
  }

    return (
      <div>
        <MDBNavbar color="top-nav-collapse" dark expand="lg" fixed="top" scrolling transparent >
          <MDBContainer>
            <MDBNavbarBrand>
              <Link to="/">
                <img src="/unicom-capital-logo-we.svg" alt="Company logo" title="UNICOM Capital, LP" className="nav-logo" />
              </Link>
            </MDBNavbarBrand>
            <MDBNavbarToggler aria-label="Mobile Navigation Button" onClick={this.handleTogglerClick} />
            <MDBCollapse isOpen={this.state.collapsed} navbar>
              <MDBNavbarNav right>
                <MDBNavItem>
                  <MDBDropdown>
                    <MDBDropdownToggle nav caret className={ this.state.parentNav === 'services' ? 'active' : '' }>
                      <span className="mr-1">Services</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-capital">
                      <MDBDropdownItem href="/services/">
                        Services
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/joint-ventures/">
                        - Joint ventures
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/mergers-acquisitions/">
                        - Mergers and acquisitions
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/special-purpose-acquisition-company/">
                        - Special purpose acquistion companies
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/initial-public-offering/">
                        - Initial public offering
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/capital-markets/">
                        - Capital markets
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/services/global-macro-strategy/">
                        - Global macro strategy
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>

                <MDBNavItem>
                <Link to="/partnerworld-advantage/" className={ this.state.parentNav === 'partnerworld-advantage' ? 'active nav-link' : 'nav-link' } aria-label="Partnerworld Advantage">
                    PartnerWorld 
                  </Link>
                </MDBNavItem>

                <MDBNavItem>
                  <MDBDropdown>
                  <MDBDropdownToggle nav caret className={ (this.state.parentNav === 'about' || this.state.parentNav === 'contact' || this.state.parentNav === 'news') ? 'active' : '' }>
                      <span className="mr-1">Company</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu className="dropdown-capital">
                      <MDBDropdownItem href="/contact/">
                        Contact us
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/news/">
                        Newsroom
                      </MDBDropdownItem>
                      <hr className="nav" />
                      <MDBDropdownItem href="/about/">
                        About Us
                      </MDBDropdownItem>
                      <MDBDropdownItem href="/about/leadership/">
                        Leadership
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                <Link to="/search/" className="nav-link d-none d-lg-block" aria-label="Search">
                    <FontAwesomeIcon icon={faSearch} />
                  </Link>
                  <Link to="/search/" className="nav-link d-lg-none d-sm-block" aria-label="Search">
                    Search
                  </Link>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>
          </MDBContainer>
        </MDBNavbar>
        {this.state.collapsed && overlay}
      </div>
    )
  }
}

export default NavBarPage
